<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" @click="doAdd()">添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-input v-model="query.title" clearable placeholder="友链标题" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column show-overflow-tooltip label="标题" width="200">
                    <template slot-scope="scope">
                        <el-tag size="mini" type="danger" style="margin-right: 10px;" effect="dark" v-if="!scope.row.show">不显示</el-tag>
                        <span>{{ scope.row.title }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="链接地址">
                    <template slot-scope="scope">
                        <span>{{ scope.row.linkurl }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="排序值" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.sort }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialog" width="600px">
            <el-form ref="form" :model="field" :rules="rules" label-width="100px">
                <el-form-item label="友链标题" prop="title">
                    <el-input v-model="field.title" placeholder="请填写友链标题"></el-input>
                </el-form-item>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="排序值" prop="sort">
                            <el-input-number style="width: 100%;" v-model="field.sort" label="请填写排序值"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否显示" prop="show">
                            <el-switch v-model="field.show" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="链接地址" prop="linkurl">
                    <el-input v-model="field.linkurl" placeholder="请填写链接地址"></el-input>
                </el-form-item>
                <el-form-item label="友链Logo" prop="image">
                    <el-upload class="imgupd-uploader" action="action" :show-file-list="false" :before-upload="beforeImageUpload" :http-request="doImageUpload">
                        <el-image v-if="field.image" style="width: 300px; height: 300px" :src="field.image" fit="scale-down"></el-image>
                        <i v-else class="el-icon-plus imgupd-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    title: ''
}
const defaultField = {
    id: '',
    title: '',
    image: '',
    show: true,
    linkurl: '',
    sort: 0
}
export default {
    name: 'CmsCarousel',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                ...defaultField
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: '请填写友链名称',
                        trigger: 'blur'
                    }
                ],
                image: [
                    {
                        required: true,
                        message: '请上传友链Logo',
                        trigger: 'blur'
                    }
                ],
                linkurl: [
                    {
                        required: true,
                        message: '请填写链接地址',
                        trigger: 'blur'
                    }
                ],
                show: [
                    {
                        required: true,
                        message: '请选择是否显示',
                        trigger: 'blur'
                    }
                ],
                sort: [
                    {
                        required: true,
                        message: '请填写排序值',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['网站管理', '友链管理'])
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/cms/blogroll/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        beforeImageUpload(file) {
            const fileType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
            const fileSize = file.size / 1024 <= 1024
            if (!fileType) {
                this.$message.error('上传图片只能是JPG或PNG格式!')
            }
            if (!fileSize) {
                this.$message.error('上传图片大小不能超过1MB!')
            }
            return fileSize && fileType
        },
        doImageUpload(upload) {
            this.$http
                .post(
                    '/comm/base/image/upload',
                    {
                        file: upload.file,
                        type: 'BImage'
                    },
                    {
                        onUploadProgress: progressEvent => {
                            const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                            upload.onProgress({
                                percent: complete
                            })
                        }
                    }
                )
                .then(result => {
                    if (result.code === 0) {
                        let obj = {
                            name: upload.file.name,
                            url: result.data.url
                        }
                        this.field.image = obj.url
                        upload.onSuccess(obj)
                    }
                })
                .catch(err => {
                    upload.onError(err)
                })
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.field = {
                ...item
            }
            this.formDialog = true
        },
        doSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/cms/blogroll/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.title)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.title)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/cms/blogroll/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        }
    }
}
</script>
